import LiveBadge from "../common/LiveBadge";
import { useLiveInfo } from "../common/LiveInfoProvider";

export default function CategoryLiveBadge(props) {
    const liveInfo = useLiveInfo();

    if (liveInfo?.liveCategories.has(props.uniqueId)) {
        return <LiveBadge className="inline-flex ml-2" />;
    }

    return null;
}
